import { useEffect, useRef } from 'react';

/**
 * Человек вернулся в приложение — из платёжки, из чата с ботом, с другого
 * экрана телефона. Mini App в это время не выгружается, и всё, что лежит в
 * кеше, могло устареть: например, оплату сделали с компа.
 *
 * `visibilitychange` — то, что WebView Telegram отдаёт при сворачивании и
 * разворачивании; на телефоне это не проверено (см. `docs/subscription.html`).
 */
export function useOnAppReturn(callback: () => void): void {
  const latest = useRef(callback);
  useEffect(() => {
    latest.current = callback;
  });
  useEffect(() => {
    const onChange = () => {
      if (document.visibilityState === 'visible') latest.current();
    };
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);
}
